"use client";

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Icon } from "@/components/ui/icon";
import type { StageItem } from "@/features/jobs/components/stage-cards";
import { ApplyJobStagePreset } from "./apply-job-stage-preset";
import { CreatePreset } from "./create";

interface StagePresetActionsProps {
  stages: StageItem[];
  onApplyStages: (stages: StageItem[]) => void;
  className?: string;
  /** When provided, the parent owns preset sheets (e.g. to swap with a parent sheet). */
  onOpenApply?: () => void;
  onOpenSave?: () => void;
}

export function StagePresetActions({
  stages,
  onApplyStages,
  className,
  onOpenApply,
  onOpenSave,
}: StagePresetActionsProps) {
  const [applyOpen, setApplyOpen] = useState(false);
  const [saveOpen, setSaveOpen] = useState(false);
  const applyControlledByParent = onOpenApply != null;
  const saveControlledByParent = onOpenSave != null;

  const handleOpenApply = () => {
    if (onOpenApply) onOpenApply();
    else setApplyOpen(true);
  };

  const handleOpenSave = () => {
    if (onOpenSave) onOpenSave();
    else setSaveOpen(true);
  };

  return (
    <>
      <div className={className ?? "flex items-center gap-2"}>
        <Button
          type="button"
          variant="secondary"
          size="sm"
          onClick={handleOpenApply}
          icon={
            <span className="opacity-50">
              <Icon
                name="IconLayoutDashboard"
                size={16}
                className="text-heading"
              />
            </span>
          }
        >
          Presets
        </Button>
        <Button
          type="button"
          variant="secondary"
          size="sm"
          onClick={handleOpenSave}
          icon={
            <span className="opacity-50">
              <Icon
                name="IconShareArrowDown"
                size={16}
                className="text-heading"
              />
            </span>
          }
        >
          Save
        </Button>
      </div>

      {!applyControlledByParent ? (
        <ApplyJobStagePreset
          open={applyOpen}
          onClose={() => setApplyOpen(false)}
          currentStages={stages}
          onApply={onApplyStages}
        />
      ) : null}

      {!saveControlledByParent ? (
        <CreatePreset
          open={saveOpen}
          onClose={() => setSaveOpen(false)}
          presetType="job-stages"
          initialStages={stages}
        />
      ) : null}
    </>
  );
}
